import React, { FC, Fragment, Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useNavigate, useParams } from 'react-router-dom';
import PatientList from './patient-list.component';
import PatientByMatBatchList from './patient-by-mat-batch-list.component';

const Patients: FC = () => {
    const { t: translate } = useTranslation(['patient']);
    const { tab } = useParams<{ tab: string }>();
    const [tabState, setTabState] = useState(tab || 'patients');
    const navigate = useNavigate();

    const handleTabChange = (_: unknown, newTabState: string) => {
        if (tabState !== newTabState) {
            navigate(`/patients/list/${newTabState}`);
            setTabState(newTabState);
        }
    };

    useEffect(() => {
        handleTabChange(undefined, tab || 'patients');
    }, [tab]);

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
                    <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                        <Tab label={translate('patient:PATIENTS')} value="patients" />
                        <Tab label={translate('patient:MAT_BATCH')} value="batch" />
                    </TabList>
                </Box>

                <TabPanel sx={{ padding: 0 }} value="patients">
                    <Suspense fallback={null}>
                        <PatientList />
                    </Suspense>
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="batch">
                    <Suspense fallback={null}>
                        <PatientByMatBatchList />
                    </Suspense>
                </TabPanel>
            </TabContext>
        </Fragment>
    );
};

export default Patients;
